import type { $Fetch, NitroFetchRequest } from "nitropack"

/**
 * Repository for form-related API calls
 */
export function formRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Get form configuration for a job application
     *
     * @param tenantId The tenant ID
     * @param jobShopId The job shop ID
     * @param acceptLanguage The accept language header
     * @param jobId The ID of the job offer
     * @param groupId The ID of the group
     * @returns Form configuration from the Content Service
     */
    async getFormConfig(tenantId: string, jobShopId: string, acceptLanguage: string, jobId: string, groupId: string | null): Promise<FormConfig> {
      const response = await fetch<FormConfig>(`${UrlConfig.PATH_BASE_CONTENT_SERVICE}/public/offers/${jobId}/application-form`, {
        headers: {
          "Accept-Language": acceptLanguage,
          "Accept": "application/json",
          "X-Tenant-Id": tenantId,
          "X-JobShop-Id": jobShopId,
        },
        ...(groupId && {
          params: {
            group_id: groupId,
          }
        })
      })

      return response
    }
  }
}
